import produce from 'immer';

import {
  CLEAR_CURRENT_ACTION,
  CREATE_ACTION_FAILURE,
  CREATE_ACTION_SUCCESS,
  FETCH_ACTION_FAILURE,
  FETCH_ACTION_LIST_FAILURE,
  FETCH_ACTION_LIST_SUCCESS,
  FETCH_ACTION_SUCCESS,
} from '@actions/configAction';

const initialState: IActionStore = {
  actions: [],
  currentAction: null,
  error: null,
};

export default (state: IActionStore = initialState, action: any) =>
  produce(state, (draftState: IActionStore) => {
    switch (action.type) {
      case FETCH_ACTION_LIST_SUCCESS:
        draftState.actions = action.response;
        draftState.error = null;

        return;

      case FETCH_ACTION_SUCCESS:
        draftState.currentAction = action.response;
        draftState.error = null;

        return;
      case CREATE_ACTION_SUCCESS:
        draftState.currentAction = null;
        draftState.error = null;

        return;
      case CREATE_ACTION_FAILURE:
      case FETCH_ACTION_LIST_FAILURE:
      case FETCH_ACTION_FAILURE:
        draftState.error = action.error;

        return;

      case CLEAR_CURRENT_ACTION:
        draftState.currentAction = null;

        return;
    }
  });
